// src/components/Chatbot.js
import React, { useState } from 'react';
import '../styles/Chatbot.css';
import { apiUrl } from '../config';

export default function Chatbot() {
  const [isOpen, setIsOpen]   = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput]     = useState('');
  const [sending, setSending] = useState(false);

  const toggleChat = () => setIsOpen(v => !v);

  const handleSend = async () => {
    const msg = input.trim();
    if (!msg || sending) return;

    setMessages(prev => [...prev, { text: msg, sender: 'user' }]);
    setInput('');
    setSending(true);

    try {
      // 🔴 no localhost; hit Vercel function
      const resp = await fetch(apiUrl('/api/chat'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: msg }),
      });

      const data = await resp.json().catch(() => ({}));
      if (!resp.ok || !data?.reply) {
        setMessages(prev => [...prev, { text: 'Error connecting to AI server.', sender: 'bot' }]);
        return;
      }
      setMessages(prev => [...prev, { text: data.reply, sender: 'bot' }]);
    } catch (e) {
      console.error('chat send error', e);
      setMessages(prev => [...prev, { text: 'Error connecting to AI server.', sender: 'bot' }]);
    } finally {
      setSending(false);
    }
  };

  return (
    <div>
      <button className="chat-button" onClick={toggleChat}>💬</button>
      {isOpen && (
        <div className="chat-popup">
          <div className="chat-header">
            <h4>Health Assistant</h4>
            <button className="close-btn" onClick={toggleChat}>&times;</button>
          </div>

          <div className="chat-messages">
            {messages.map((m, i) => (
              <div key={i} className={`message ${m.sender}`}>{m.text}</div>
            ))}
          </div>

          <div className="chat-input">
            <input
              type="text"
              placeholder={sending ? 'Sending…' : 'Ask me anything…'}
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSend()}
              disabled={sending}
            />
            <button onClick={handleSend} disabled={sending}>Send</button>
          </div>
        </div>
      )}
    </div>
  );
}